import Profile from './index';
import { IRoute } from '../../utils/navigation/routes';
import CustomerAgreement from './CustomerAgreement';
import FeedbackAgreement from './CustomerAgreement/feedbackAgreement';
import PersonalData from './personalData';
import AddPersonalData from './personalData/addPersonalData';
import FeedbackAddData from './personalData/addPersonalData/feedbackAddData';
import ChangePersonalData from './personalData/changePersonalData';
import FeedbackChangeData from './personalData/changePersonalData/feedbackChangeData';
import UpdatePassword from './updatePassword';
import UpdatePasswordFeedback from './updatePassword/UpdatePasswordFeedback';

export const profileRoutes: IRoute[] = [
    { path: '/profile', element: <Profile /> },
    { path: '/profile/personal-data', element: <PersonalData /> },
    { path: '/profile/customer-agreement', element: <CustomerAgreement /> },
    { path: '/profile/customer-agreement/feedback', element: <FeedbackAgreement /> },
    { path: '/profile/personal-data/change', element: <ChangePersonalData /> },
    { path: '/profile/personal-data/change/feedback', element: <FeedbackChangeData /> },
    { path: '/profile/personal-data/add', element: <AddPersonalData /> },
    { path: '/profile/personal-data/add/feedback', element: <FeedbackAddData /> },
    { path: '/profile/update-password', element: <UpdatePassword /> },
    { path: '/profile/update-password/feedback', element: <UpdatePasswordFeedback /> },
];
